import { IDynamicComponentManifest, IEditorManifest } from '@adaptiva/core/loaders';
import { EJavaClassNames, PlatformEditorUrls } from '@adaptiva/data-service';
import { FormEditorUrls } from '@adaptiva/forms/common';
import { EServerOverlayIds } from '@adaptiva/server/overlays';
import { SERVER_DYNAMIC_COMPONENT_MANIFESTS } from '@adaptiva/server/views';
import { OBJECT_LIST_MANIFEST } from '@adaptiva/widgets/object-list';
import { WorkflowEditorUrls } from '@adaptiva/workflows/common';

const EDITOR_MANIFESTS: IEditorManifest[] = [
	{
		className: EJavaClassNames.ActionServerObject,
		componentId: `editor:${EJavaClassNames.ActionServerObject}`,
		editorUrls: [PlatformEditorUrls.ACTION_SERVER_OBJECT],
		path: PlatformEditorUrls.ACTION_SERVER_OBJECT,
		loadChildren: () => import('./views/actions/editor').then(m => m.ActionEditorAreaModule),
	},
	{
		className: EJavaClassNames.AdaptivaPackage,
		componentId: `editor:${EJavaClassNames.AdaptivaPackage}`,
		editorUrls: [PlatformEditorUrls.ADAPTIVA_PACKAGE],
		path: PlatformEditorUrls.ADAPTIVA_PACKAGE,
		loadChildren: () => import('./views/adaptiva-content/editor').then(m => m.AdaptivaContentEditorAreaModule)
	},
	{
		className: EJavaClassNames.Administrator,
		componentId: `editor:${EJavaClassNames.Administrator}`,
		editorUrls: [PlatformEditorUrls.ADMINISTRATOR],
		path: PlatformEditorUrls.ADMINISTRATOR,
		loadChildren: () => import('./views/cloud-settings/security/administrator/editor').then(m => m.AdministratorEditorAreaModule)
	},
	{
		className: EJavaClassNames.OidcCertificateClient,
		componentId: `editor:${EJavaClassNames.OidcCertificateClient}`,
		editorUrls: [PlatformEditorUrls.OIDC_CERTIFICATE_CLIENT],
		path: PlatformEditorUrls.OIDC_CERTIFICATE_CLIENT,
		loadChildren: () => import('./views/cloud-settings/security/oidc-certificate-client').then(m => m.OidcCertificateClientEditorAreaModule)
	},
	{
		className: EJavaClassNames.ClassLevelPermissions,
		componentId: `editor:${EJavaClassNames.ClassLevelPermissions}`,
		editorUrls: [PlatformEditorUrls.CLASS_LEVEL_PERMISSIONS],
		path: PlatformEditorUrls.CLASS_LEVEL_PERMISSIONS,
		loadChildren: () => import('./views/cloud-settings/security/class-permissions/editor').then(m => m.ClassPermissionsEditorAreaModule)
	},
	{
		className: EJavaClassNames.ClientSettingsServerPolicy,
		componentId: `editor:${EJavaClassNames.ClientSettingsServerPolicy}`,
		editorUrls: [PlatformEditorUrls.CLIENT_SETTINGS_SERVER_POLICY],
		path: PlatformEditorUrls.CLIENT_SETTINGS_SERVER_POLICY,
		loadChildren: () => import('./views/cloud-settings').then(
			m => m.ClientServerPoliciesEditorAreaModule
		)
	},
	{
		className: EJavaClassNames.ClientWorkflowExecutionPolicy,
		componentId: `editor:${EJavaClassNames.ClientWorkflowExecutionPolicy}`,
		editorUrls: [WorkflowEditorUrls.CLIENT_WORKFLOW_EXECUTION_POLICY],
		path: WorkflowEditorUrls.CLIENT_WORKFLOW_EXECUTION_POLICY,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.ClientWorkflowExecutionPolicyEditorAreaModule)
	},
	{
		className: EJavaClassNames.ContentPushServerPolicy,
		componentId: `editor:${EJavaClassNames.ContentPushServerPolicy}`,
		editorUrls: [PlatformEditorUrls.CONTENT_PUSH_SERVER_POLICY],
		path: PlatformEditorUrls.CONTENT_PUSH_SERVER_POLICY,
		loadChildren: () => import('./views/content-push/editor').then(m => m.ContentPushEditorAreaComponentModule)
	},
	{
		className: EJavaClassNames.CustomToolObject,
		componentId: `editor:${EJavaClassNames.CustomToolObject}`,
		editorUrls: [WorkflowEditorUrls.CUSTOM_TOOL_OBJECT],
		path: WorkflowEditorUrls.CUSTOM_TOOL_OBJECT,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.CustomToolEditorModule)
	},
	{
		className: EJavaClassNames.DataProvider,
		componentId: `editor:${EJavaClassNames.DataProvider}`,
		editorUrls: [PlatformEditorUrls.DATA_PROVIDER],
		path: PlatformEditorUrls.DATA_PROVIDER,
		loadChildren: () => import('./views/dashboards/data-providers/editor').then(m => m.DataProviderEditorAreaModule)
	},
	{
		className: EJavaClassNames.FolderLevelPermissions,
		componentId: `editor:${EJavaClassNames.FolderLevelPermissions}`,
		editorUrls: [''],
		path: '',
		loadChildren: () => import('./views/cloud-settings/security/folder-permissions').then(m => m.FolderPermissionsEditorAreaModule)
	},
	{
		className: EJavaClassNames.Group,
		componentId: `editor:${EJavaClassNames.Group}`,
		editorUrls: [PlatformEditorUrls.GROUP],
		path: PlatformEditorUrls.GROUP,
		loadChildren: () => import('./views/assets/groups/editor').then(m => m.GroupEditorAreaModule)
	},
	{
		className: EJavaClassNames.InventoryPolicy,
		componentId: `editor:${EJavaClassNames.InventoryPolicy}`,
		editorUrls: [PlatformEditorUrls.INVENTORY_POLICY],
		path: PlatformEditorUrls.INVENTORY_POLICY,
		loadChildren: () => import('@adaptiva/telemetry/views').then(m => m.InventoryPolicyEditorAreaModule)
	},
	{
		className: EJavaClassNames.LaunchOnScheduleSettings,
		componentId: `editor:${EJavaClassNames.LaunchOnScheduleSettings}`,
		editorUrls: [''],
		path: '',
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.LaunchOnScheduleSettingsEditorAreaModule)
	},
	{
		className: EJavaClassNames.ObjectLevelPermissions,
		componentId: `editor:${EJavaClassNames.ObjectLevelPermissions}`,
		editorUrls: [''],
		path: '',
		loadChildren: () => import('./views/cloud-settings/security/object-permissions').then(m => m.ObjectPermissionsEditorAreaModule)
	},
	{
		className: EJavaClassNames.Office,
		componentId: `editor:${EJavaClassNames.Office}`,
		editorUrls: [PlatformEditorUrls.OFFICE],
		path: PlatformEditorUrls.OFFICE,
		loadChildren: () => import('./views/assets/locations/editor').then(m => m.LocationEditorAreaModule)
	},
	{
		className: EJavaClassNames.OidcProvider,
		componentId: `editor:${EJavaClassNames.OidcProvider}`,
		editorUrls: [PlatformEditorUrls.OIDC_PROVIDER],
		path: 'oidc-provider-editor-area-component',
		loadChildren: () => import('../app/views/cloud-settings/security').then(m => m.OidcProviderEditorAreaModule)
	},
	{
		className: EJavaClassNames.PSCmdletObject,
		componentId: `editor:${EJavaClassNames.PSCmdletObject}`,
		editorUrls: [PlatformEditorUrls.POWERSHELL_CMDLET_OBJECT],
		path: PlatformEditorUrls.POWERSHELL_CMDLET_OBJECT,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.PowerShellCmdletEditorModule)
	},
	{
		className: EJavaClassNames.RestApiEndpoint,
		componentId: `editor:${EJavaClassNames.RestApiEndpoint}`,
		editorUrls: [PlatformEditorUrls.REST_API_ENDPOINT],
		path: PlatformEditorUrls.REST_API_ENDPOINT,
		loadChildren: () => import('./views/cloud-settings/rest-apis/endpoints').then(m => m.RestApiEditorAreaModule)
	},
	{
		className: EJavaClassNames.Role,
		componentId: `editor:${EJavaClassNames.Role}`,
		editorUrls: [PlatformEditorUrls.ROLE],
		path: PlatformEditorUrls.ROLE,
		loadChildren: () => import('./views/cloud-settings/security/role').then(m => m.RoleEditorAreaModule)
	},
	{
		className: EJavaClassNames.SamlProvider,
		componentId: `editor:${EJavaClassNames.SamlProvider}`,
		editorUrls: [PlatformEditorUrls.SAML_PROVIDER],
		path: '',
		loadChildren: () => import('./views/cloud-settings/security/saml-providers').then(m => m.SamlProviderEditorModule)
	},
	{
		className: EJavaClassNames.Schedule,
		componentId: `editor:${EJavaClassNames.Schedule}`,
		editorUrls: [PlatformEditorUrls.SCHEDULE],
		path: PlatformEditorUrls.SCHEDULE,
		loadChildren: () => import('./views/schedule/schedule-editor-area/schedule-editor-area.component.module').then(
			m => m.ScheduleEditorAreaComponentModule
		)
	},
	{
		className: EJavaClassNames.SensorServerObject,
		componentId: `editor:${EJavaClassNames.SensorServerObject}`,
		editorUrls: [PlatformEditorUrls.SENSOR_SERVER_OBJECT],
		path: PlatformEditorUrls.SENSOR_SERVER_OBJECT,
		loadChildren: () => import('@adaptiva/server/views').then(m => m.SensorsEditorAreaModule)
	},
	{
		className: EJavaClassNames.SensorActionExecutionPolicy,
		componentId: `editor:${EJavaClassNames.SensorActionExecutionPolicy}`,
		editorUrls: [PlatformEditorUrls.SENSOR_ACTION_EXECUTION_POLICY],
		path: PlatformEditorUrls.SENSOR_ACTION_EXECUTION_POLICY,
		loadChildren: () => import('./views/sensor-action-execution-policy/sensor-action-execution-policy-editor-area').then(
			m => m.SensorActionExecutionPolicyEditorAreaModule
		)
	},
	{
		className: EJavaClassNames.ServerWorkflowExecutionPolicy,
		componentId: `editor:${EJavaClassNames.ServerWorkflowExecutionPolicy}`,
		editorUrls: [PlatformEditorUrls.SERVER_WORKFLOW_EXECTION_POLICY],
		path: PlatformEditorUrls.SERVER_WORKFLOW_EXECTION_POLICY,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.ServerWorkflowExecutionPolicyEditorModule)
	},
	{
		className: EJavaClassNames.SurveyServerObject,
		componentId: `editor:${EJavaClassNames.SurveyServerObject}`,
		editorUrls: [FormEditorUrls.SURVEY_SERVER_OBJECT],
		path: FormEditorUrls.SURVEY_SERVER_OBJECT,
		loadChildren: () => import('./views/surveys/survey-editor/survey-editor-area/survey-editor-area.component.module').then(
			m => m.SurveyEditorAreaModule
		)
	},
	{
		className: EJavaClassNames.Tenant,
		componentId: `editor:${EJavaClassNames.Tenant}`,
		editorUrls: [PlatformEditorUrls.TENANT],
		path: PlatformEditorUrls.TENANT,
		loadChildren: () => import('./views/assets/tenants').then(m => m.TenantEditorAreaModule)
	},
	{
		className: EJavaClassNames.Theme,
		componentId: `editor:${EJavaClassNames.Theme}`,
		editorUrls: [PlatformEditorUrls.THEME],
		path: PlatformEditorUrls.THEME,
		loadChildren: () => import('./views/themes').then(m =>
			m.ThemesEditorAreaModule
		),
	},
	{
		className: EJavaClassNames.UserDashboardSubscription,
		componentId: `editor:${EJavaClassNames.UserDashboardSubscription}`,
		editorUrls: [PlatformEditorUrls.USER_DASHBOARD_SUBSCRIPTION],
		path: PlatformEditorUrls.USER_DASHBOARD_SUBSCRIPTION,
		loadChildren: () => import('@adaptiva/dashboards/views').then(m => m.UserDashboardSubscriptionEditorAreaModule)
	},
	{
		className: EJavaClassNames.WebForm,
		componentId: `editor:${EJavaClassNames.WebForm}`,
		editorUrls: [PlatformEditorUrls.WEBFORM],
		path: PlatformEditorUrls.WEBFORM,
		loadChildren: () => import('@adaptiva/forms/views').then(m => m.FormEditorAreaModule)
	},
	{
		className: EJavaClassNames.Workflow,
		componentId: `editor:${EJavaClassNames.Workflow}`,
		editorUrls: [PlatformEditorUrls.WORKFLOW],
		path: PlatformEditorUrls.WORKFLOW,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.WorkflowEditorAreaComponentModule)
	},
	{
		className: EJavaClassNames.WorkflowActivity,
		componentId: `editor:${EJavaClassNames.WorkflowActivity}`,
		editorUrls: [WorkflowEditorUrls.WORKFLOW_ACTIVITY],
		path: WorkflowEditorUrls.WORKFLOW_ACTIVITY,
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.ProcedureActivityEditorAreaModule)
	},
	{
		className: EJavaClassNames.WorkflowRoutingRule,
		componentId: `editor:${EJavaClassNames.WorkflowRoutingRule}`,
		editorUrls: [''],
		path: '',
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.WorkflowRoutingRuleEditorAreaComponentModule)
	},
	{
		className: EJavaClassNames.ClientTrustedCertificate,
		componentId: `editor:${EJavaClassNames.ClientTrustedCertificate}`,
		editorUrls: [PlatformEditorUrls.CLIENT_TRUSTED_CERTIFICATE],
		path: '',
		loadChildren: () => import('./views/cloud-settings').then(m => m.ClientTrustedCertificateModule)
	},
	{
		className: EJavaClassNames.ClientTrustedCertificatePolicy,
		componentId: `editor:${EJavaClassNames.ClientTrustedCertificatePolicy}`,
		editorUrls: [PlatformEditorUrls.CLIENT_TRUSTED_CERTIFICATE_POLICIES],
		path: '',
		loadChildren: () => import('./views/cloud-settings').then(m => m.ClientTrustedCertificatePolicyModule)
	},
];

const STANDALONE_EDITORS: IDynamicComponentManifest[] = [
	{
		componentId: 'blob-storage-settings-editor',
		path: 'blob-storage-settings-editor',
		loadChildren: () => import('./views/cloud-settings/blob-storage-settings/blob-storage-settings.module').then(
			m => m.BlobStorageSettingsModule
		)
	},
	{
		componentId: 'sensor-offline-cache-settings-editor',
		path: 'sensor-offline-cache-settings-editor',
		loadChildren: () => import('./views/cloud-settings/sensor-offline-cache-settings').then(m => m.SensorOfflineCacheSettingsEditorModule)
	},
	{
		componentId: 'event-notification-settings-editor',
		path: 'event-notification-settings-editor',
		loadChildren: () => import('./views/cloud-settings/event-notification-settings').then(m => m.EventNotificationSettingsEditorModule)
	},
	{
		componentId: 'cloud-content-settings-editor',
		path: 'cloud-content-settings-editor',
		loadChildren: () => import('./views/cloud-settings/cloud-content-settings/cloud-content-settings-editor.module').then(
			m => m.CloudContentSettingsEditorModule
		)
	},
	{
		componentId: 'intune-cloud-content-settings-editor',
		path: 'intune-cloud-content-settings-editor',
		loadChildren: () => import('./views/onesite/onesite-intune').then(m => m.OneSiteIntuneCloudContentSettingsEditorModule)
	},

	{
		componentId: 'client-auth-editor',
		path: 'client-auth-editor',
		loadChildren: () => import('./views/cloud-settings/client-auth-editor/client-auth-editor.component.module').then(
			m => m.ClientAuthEditorComponentModule
		)
	},
	{
		componentId: 'auto-location-creation-editor',
		path: 'auto-location-creation-editor',
		loadChildren: () => import('./views/assets/locations/auto-location-creation').then(m => m.AutoLocationCreationEditorModule)
	},
	{
		componentId: 'rest-api-configuration-editor',
		path: 'rest-api-configuration-editor',
		loadChildren: () => import('./views/cloud-settings/rest-apis/configuration').then(m => m.RestApiConfigEditorModule)
	},
	{
		componentId: `editor:${EJavaClassNames.OnPremisesDetectionPolicy}`,
		path: 'on-premises-network-topology-editor',
		loadChildren: () => import('./views/assets/locations').then(m => m.OnPremisesNetworkTopologyEditorModule)
	},
];

const DYNAMIC_COMPONENTS: IDynamicComponentManifest[] = [
	// overlays
	{
		componentId: 'ReferenceTreeActionOverlayComponent',
		path: 'reference-tree-action',
		loadChildren: () => import('./components/actions').then(m => m.ReferenceTreeActionOverlayComponentModule)
	},
	{
		componentId: 'NewFolderActionOverlayComponent',
		path: 'new-folder-action',
		loadChildren: () => import('./components/actions').then(m => m.NewFolderActionOverlayComponentModule)
	},
	{
		componentId: 'MergeOfficesActionOverlayComponent',
		path: 'merge-offices-action',
		loadChildren: () => import('./components/actions').then(m => m.MergeOfficesActionOverlayComponentModule)
	},
	{
		componentId: 'ViewClientsActionOverlayComponent',
		path: 'view-clients-action',
		loadChildren: () => import('./components/actions').then(m => m.ViewClientsActionOverlayComponentModule)
	},
	{
		componentId: 'RenameActionOverlayComponent',
		path: 'rename-object-action',
		loadChildren: () => import('./components/actions').then(m => m.RenameActionOverlayComponentModule)
	},
	{
		componentId: 'ObjectTransferActionOverlayComponent',
		path: 'object-transfer-action',
		loadChildren: () => import('./components/actions').then(m => m.ObjectTransferActionOverlayComponentModule)
	},
	{
		componentId: 'RenameMetadataActionOverlayComponent',
		path: 'rename-metadata-object-action',
		loadChildren: () => import('./components/actions').then(m => m.RenameMetadataActionOverlayComponentModule)
	},
	{
		componentId: 'SaveAsActionOverlayComponent',
		path: 'save-as-action',
		loadChildren: () => import('./components/actions').then(m => m.SaveAsActionOverlayComponentModule)
	},
	{
		componentId: 'MoveOfficesActionOverlayComponent',
		path: 'move-offices-action',
		loadChildren: () => import('./components/actions').then(m => m.MoveOfficesActionOverlayComponentModule)
	},
	{
		componentId: 'ContentBrowserErrorsActionOverlayComponent',
		path: 'content-browser-errors',
		loadChildren: () => import('./components/actions').then(m => m.ContentBrowserErrorsActionOverlayComponentModule)
	},
	{
		componentId: 'PreviewThemeActionOverlayComponent',
		path: 'preview-theme',
		loadChildren: () => import('./components/actions').then(m => m.PreviewThemeActionOverlayComponentModule)
	},
	{
		componentId: 'RejectActionOverlayComponent',
		path: 'reject-action-overlay',
		loadChildren: () => import('./components/actions').then(m => m.RejectActionOverlayComponentModule)
	},
	{
		componentId: 'ChangePasswordOverlayComponent',
		path: 'change-password-action',
		loadChildren: () => import('./components/actions/change-password-overlay/change-password-overlay.component.module').then(
			m => m.ChangePasswordOverlayComponentModule
		)
	},
	{
		componentId: 'WorkflowDeployActionOverlayComponent',
		path: 'workflow-deploy',
		loadChildren: () => import('./components/actions/workflow-deployment').then(m => m.WorkflowDeployActionOverlayComponentModule)
	},
	{
		componentId: 'WorkflowUndeployActionOverlayComponent',
		path: 'workflow-undeploy',
		loadChildren: () => import('./components/actions').then(m => m.WorkflowUndeployActionOverlayComponentModule)
	},
	{
		componentId: 'WorkflowChangeExecutionSettingsActionOverlayComponent',
		path: 'workflow-change-exectuion-settings',
		loadChildren: () => import('./components/actions').then(
			m => m.WorkflowChangeExecutionSettingsActionOverlayComponentModule
		)
	},
	{
		componentId: 'WorkflowRoutingRulesActionOverlayComponent',
		path: 'workflow-routing-rules',
		loadChildren: () => import('./components/actions').then(m => m.WorkflowRoutingRulesActionOverlayComponentModule)
	},
	{
		componentId: 'FolderLevelPermissionsComponent',
		path: 'folder-level-permissions-overlay',
		loadChildren: () => import('./components/actions/folder-level-permissions/folder-level-permissions.module').then(
			m => m.FolderLevelPermissionsModule
		)
	},
	{
		componentId: 'ObjectLevelPermissionsComponent',
		path: 'object-level-permissions-overlay',
		loadChildren: () => import('./components/actions/object-level-permissions/object-level-permissions.module').then(
			m => m.ObjectLevelPermissionsModule
		)
	},
	{
		componentId: 'ClassPermissionsOverlayComponent',
		path: 'class-level-permissions-overlay',
		loadChildren: () => import('./components/actions').then(m => m.ClassPermissionsOverlayModule)
	},
	{
		componentId: 'BrowserOverlayComponent',
		path: 'browser-overlay',
		loadChildren: () => import('./components/actions').then(m => m.BrowserOverlayModule)
	},
	{
		componentId: 'ExplorerOverlayComponent',
		path: 'explorer-overlay',
		loadChildren: () => import('./components/actions').then(m => m.ExplorerOverlayComponent)
	},
	{
		componentId: 'ObjectGridOverlayComponent',
		path: 'object-grid-overlay',
		loadChildren: () => import('./components/actions').then(m => m.ObjectGridOverlayModule),
	},
	{
		componentId: 'WorkflowStatusActionOverlayComponent',
		path: 'workflow-manage-deployments',
		loadChildren: () => import('./components/actions').then(m => m.WorkflowStatusActionOverlayComponentModule)
	},
	{
		componentId: 'CustomActivityOverlayComponent',
		path: 'workflow-activity-custom-activity',
		loadChildren: () => import('./components/actions').then(m => m.CustomActivityOverlayComponentModule)
	},
	{
		componentId: 'VbScriptActivityOverlayComponent',
		path: 'workflow-activity-vb-activity',
		loadChildren: () => import('./components/actions').then(m => m.VbScriptActivityOverlayComponentModule)
	},
	{
		componentId: 'PowerShellActivityOverlayComponent',
		path: 'workflow-activity-powershell-activity',
		loadChildren: () => import('./components/actions').then(m => m.PowerShellActivityOverlayComponentModule)
	},
	{
		componentId: 'JavaActivityOverlayComponent',
		path: 'workflow-activity-java-activity',
		loadChildren: () => import('./components/actions').then(m => m.JavaActivityOverlayComponentModule)
	},
	{
		componentId: 'WorkflowLaunchFormOverlayComponent',
		path: 'workflow-launch-form-overlay',
		loadChildren: () => import('./components/actions').then(
			m => m.WorkflowLaunchFormOverlayModule
		)
	},
	{
		componentId: 'DeleteWorkflowOverlayComponent',
		path: 'delete-workflow-overlay',
		loadChildren: () => import('./components/actions').then(m => m.DeleteWorkflowOverlayModule)
	},
	{
		componentId: 'ManageBusinessWorkflowOverlayComponent',
		path: 'manage-business-workflow-overlay',
		loadChildren: () => import('./components/actions').then(m => m.ManageBusinessWorkflowOverlayModule)
	},
	{
		componentId: 'BlacklistPatchesOverlayComponent',
		path: 'blacklisted-patch-overlay',
		loadChildren: () => import('./components/actions').then(m => m.BlacklistPatchesOverlayModule)
	},
	{
		componentId: 'AnywhereEditorOverlayComponent',
		path: 'anywhere-editor-overlay',
		loadChildren: () => import('./components/actions').then(m => m.AnywhereEditorOverlayModule)
	},
	{
		componentId: 'PromptOverlayComponent',
		path: 'prompt-overlay',
		loadChildren: () => import('./components/actions').then(m => m.PromptOverlayModule)
	},
	{
		componentId: 'FormButtonOverlayComponent',
		path: 'form-button-overlay',
		loadChildren: () => import('./components/actions').then(m => m.FormButtonOverlayModule)
	},
	{
		componentId: 'ResolveBusinessUnitParentSelectionOverlay',
		path: 'resolve-business-unit-parent-selection',
		loadChildren: () => import('./components/actions/exim').then(m => m.ResolveBusinessUnitParentSelectionOverlayModule)
	},
	{
		componentId: 'ResolveBusinessUnitChildSelectionOverlay',
		path: 'resolve-business-unit-child-selection',
		loadChildren: () => import('./components/actions/exim').then(m => m.ResolveBusinessUnitChildSelectionOverlayModule)
	},
	{
		componentId: 'ResolveFolderSelectionOverlay',
		path: 'resolve-folder-selection-overlay',
		loadChildren: () => import('./components/actions/exim').then(m => m.ResolveFolderSelectionOverlayModule)
	},
	{
		componentId: 'KeybindOverlayComponent',
		path: 'keybind-overlay-component',
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.KeybindOverlayModule)
	},
	{
		componentId: 'WorkflowSettingsOverlayComponent',
		path: 'workflow-settings-overlay-component',
		loadChildren: () => import('@adaptiva/workflows/views').then(m => m.WorkflowSettingsOverlayModule)
	},
	{
		componentId: 'DashboardDrilldownTableOverlay',
		path: 'dashboard-drilldown-table-overlay',
		loadChildren: () => import('@adaptiva/dashboards/common').then(m => m.DashboardDrilldownTableOverlayModule)
	},
	{
		componentId: 'PatchScanRequestOverlay',
		path: 'patch-scan-request-overlay',
		loadChildren: () => import('./components/actions/patch-requests').then(m => m.PatchScanRequestActionOverlayComponentModule)
	},
	{
		componentId: 'PatchFailureResetRequestOverlay',
		path: 'patch-failure-reset-request-overlay',
		loadChildren: () => import('./components/actions/patch-requests').then(m => m.PatchFailureResetRequestOverlayModule)
	},
	{
		componentId: 'SensorActionPolicyInputOverlayComponent',
		path: 'sensor-action-policy-input-overlay',
		loadChildren: () => import('./views/sensor-action-execution-policy/').then(m => m.SensorActionPolicyInputOverlayModule)
	},
	{
		componentId: 'SensorActionPolicyResultOverlayComponent',
		path: 'sensor-action-policy-result-overlay',
		loadChildren: () => import('./views/sensor-action-execution-policy/sensor-action-policy-result-overlay').then(m => m.SensorActionPolicyResultOverlayModule)
	},
	{
		componentId: 'ObjectDiffOverlayComponent',
		path: 'object-diff-overlay-component',
		loadChildren: () => import('./components/actions/object-diff').then(m => m.ObjectDiffOverlayModule)
	},
	{
		componentId: 'ClientSelectorOverlay',
		path: 'client-selector-overlay',
		loadChildren: () => import('@adaptiva/widgets/client-selector').then(m => m.ClientSelectorOverlayModule)
	},
	{
		componentId: 'EulaOverlayComponent',
		path: 'eula-overlay',
		loadChildren: () => import('./components/actions/eula').then(m => m.EulaOverlayModule)
	},
	{
		componentId: 'StandaloneEditorOverlay',
		path: 'standalone-editor-overlay',
		loadChildren: () => import('./components/actions/standalone-editor').then(m => m.StandaloneEditorOverlayModule)
	},
	{
		componentId: 'CycleInfoOverlay',
		path: 'cycle-info-overlay',
		loadChildren: () => import('@adaptiva/patching/views').then(m => m.CycleInfoOverlayModule)
	},
	{
		componentId: 'ClipboardAccessOverlayComponent',
		path: 'ada-clipboard-access-overlay',
		loadChildren: () => import('./components/actions/clipboard-access-overlay').then(m => m.ClipboardAccessOverlayModule)
	},
	{
		componentId: 'ColumnStylingOverlayComponent',
		path: 'ada-column-styling-overlay',
		loadChildren: () => import('./components/actions/column-styling-overlay').then(m => m.ColumnStylingOverlayModule)
	},
	{
		componentId: 'ManageAccountOverlayComponent',
		path: 'ada-manage-account-overlay',
		loadChildren: () => import('./components/actions/manage-account-overlay').then(m => m.ManageAccountOverlayModule)
	},
	{
		componentId: 'ClientDownloadLinksOverlayComponent',
		path: 'ada-client-download-links-overlay',
		loadChildren: () => import('./components/actions/client-download-links-overlay/client-download-links-overlay.module')
			.then(m => m.ClientDownloadLinksOverlayModule)
	},
	{
		componentId: 'TextModalComponent',
		path: 'ada-text-modal-component',
		loadChildren: () => import('@adaptiva/widgets/text-modal').then(m => m.TextModalComponent)
	},
	{
		componentId: 'DebugConsoleComponent',
		path: 'ada-debug-console-component',
		loadChildren: () => import('@adaptiva/widgets/debug-console').then(m => m.DebugConsoleComponent)
	},
	{
		componentId: 'MfaSetupOverlayComponent',
		path: 'ada-mfa-setup-overlay',
		loadChildren: () => import('./components/actions/mfa-setup/mfa-setup-overlay.module').then(m => m.MfaSetupOverlayComponentModule),
	},
	{
		componentId: 'MfaLoginOverlayComponent',
		path: 'ada-mfa-login-overlay',
		loadChildren: () => import('./components/actions/mfa-login/mfa-login-overlay.module').then(m => m.MfaLoginOverlayComponentModule),
	},
	{
		componentId: 'EditorConflictOverlayComponent',
		path: 'ada-editor-conflict-overlay',
		loadChildren: () => import('./components/actions/editor-conflict/editor-conflict-overlay.module').then(m => m.EditorConflictOverlayModule),
	},
	{
		componentId: 'GroupMembersOverlayComponent',
		path: 'group-members-overlay',
		loadChildren: () => import('./components/actions').then(m => m.GroupMembersOverlayComponent)
	},
	{
		componentId: 'AddDevicesToGroupOverlayComponent',
		path: 'add-devices-to-group-overlay',
		loadChildren: () => import('./components/actions').then(m => m.AddDevicesToGroupOverlayComponent)
	},
	{
		componentId: EServerOverlayIds.SENSOR_RESET_OVERLAY,
		path: 'sensor-reset-overlay',
		loadChildren: () => import('@adaptiva/server/overlays').then(m => m.SensorResetOverlayComponent)
	},
	{
		componentId: 'ClientLogOverlayComponent',
		path: 'client-log-overlay-component',
		loadChildren: () => import('./components/actions').then(m => m.ClientLogOverlayComponent)
	}
];

export const DYNAMIC_COMPONENT_MANIFESTS: (IDynamicComponentManifest | IEditorManifest)[] = [
	...DYNAMIC_COMPONENTS,
	...EDITOR_MANIFESTS,
	...OBJECT_LIST_MANIFEST,
	...STANDALONE_EDITORS,
	...SERVER_DYNAMIC_COMPONENT_MANIFESTS,
];
